import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'rut.js';

@Pipe({ name: 'rut' })
export class RutFormatterPipe implements PipeTransform {
  transform(value: string): string {
    return format(value);
  }
}
